import React, { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  clearInputErrors,
  selectInputErrors,
} from "../../features/errors/errorsSlice";
import { Link } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";

import {
  AccommodationAttributeQueryFilters,
  AccommodationDetailsBasic,
  getAccommodationAttributesAsync,
  getAllAccommodationAttributesAsync,
  selectAccommodationAttributes,
  selectAccommodationAttributesLoadingStatus,
  selectAllAccommodationAttributes,
  selectAllAccommodationAttributesLoadingStatus,
} from "./accommodationSlice";
import { LOADING_STATUS } from "../../common/constants";

const AccommodationServices = ({
  accommodationDetailsBasic,
}: {
  accommodationDetailsBasic: AccommodationDetailsBasic;
}) => {
  const inputErrors = useAppSelector(selectInputErrors);
  const accommodationAttributesLoadingStatus = useAppSelector(
    selectAccommodationAttributesLoadingStatus,
  );
  const allAccommodationAttributesLoadingStatus = useAppSelector(
    selectAllAccommodationAttributesLoadingStatus,
  );
  const accommodationAttributes = useAppSelector(selectAccommodationAttributes);
  const allAccommodationAttributes = useAppSelector(
    selectAllAccommodationAttributes,
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getAllAccommodationAttributesAsync(filteringAttr));
    dispatch(getAccommodationAttributesAsync(accommodationDetailsBasic.id));
  }, []);
  function getAttributeIsVarustelu(attributeDefinitionId) {
    const retVal = "";
    const attributeDetails = allAccommodationAttributes.filter(
      (item) =>
        attributeDefinitionId === item.id && item.groupName === "Varustelu",
    );
    return attributeDetails !== null && attributeDetails.length > 0;
  }

  const [filteringAttr, setFilteringAttr] =
    useState<AccommodationAttributeQueryFilters>({
      pageSize: 500,
      pageNumber: 1,
    });

  function getAttributeItem(attributeDefinitionId) {
    let retVal = "";
    const attributeDetails = allAccommodationAttributes.filter(
      (item) => attributeDefinitionId === item.id,
    );
    if (attributeDetails !== null && attributeDetails.length > 0) {
      retVal = attributeDetails[0].name;
    }
    return retVal;
  }
  function getAttributeItemType(attributeDefinitionId) {
    let retVal = "";
    if (allAccommodationAttributesLoadingStatus === LOADING_STATUS.IDLE) {
      const attributeDetails = allAccommodationAttributes.filter(
        (item) => attributeDefinitionId === item.id,
      );
      retVal =
        attributeDetails != null && attributeDetails.length > 0
          ? attributeDetails[0].attributeType.typeName
          : "";
    }
    return retVal;
  }
  function getAttributeItemValue(
    attributeDefinitionId: string,
    itemv: any,
  ): string {
    let retVal = "";
    const attributeDetails = allAccommodationAttributes.filter(
      (item) => attributeDefinitionId === item.id,
    );

    if (
      attributeDetails !== null &&
      attributeDetails.length > 0 &&
      attributeDetails[0].attributeType.typeName === "NumericPlain"
    ) {
      retVal = itemv.intValue !== null ? itemv.intValue : "";
    } else if (
      attributeDetails !== null &&
      attributeDetails.length > 0 &&
      attributeDetails[0].attributeType.typeName === "FreeText"
    ) {
      retVal = itemv.textValue !== null ? itemv.textValue : "";
    } else if (
      attributeDetails !== null &&
      attributeDetails.length > 0 &&
      attributeDetails[0].attributeType.typeName === "NumericMin"
    ) {
      retVal = itemv.floatValue !== null ? itemv.floatValue : "";
    } else if (
      attributeDetails !== null &&
      attributeDetails.length > 0 &&
      attributeDetails[0].attributeType.typeName === "MultiSelect"
    ) {
      if (itemv.optionValue !== null && typeof itemv.optionValue === "object") {
        if (itemv.optionValue.length > 0) {
          for (let i = 0, l = itemv.optionValue.length; i < l; i += 1) {
            const optionId = itemv.optionValue[i].value;
            const val = itemv.multiSelectOptions.find(
              (iter) => iter.id === optionId,
            );
            if (val !== null && val !== undefined) {
              if (val.nameFi !== null && val.nameFi !== undefined) {
                retVal +=
                  val !== null && val.nameFi !== null ? (val.nameFi ?? "") : "";
                retVal += ", ";
              }
            }
          }
        }
      } else if (
        itemv.multiSelectOptions != null &&
        itemv.optionValue != null
      ) {
        retVal = itemv.multiSelectOptions[itemv.optionValue].nameFi;
      }
      // Trim trailing comma and whitespace
      retVal = retVal.trim().replace(/,\s*$/, "");
    } else if (
      attributeDetails !== null &&
      attributeDetails.length > 0 &&
      attributeDetails[0].attributeType.typeName === "Boolean"
    ) {
      retVal = itemv.booleanValue !== null ? itemv.booleanValue : false;
    } else if (
      attributeDetails !== null &&
      attributeDetails.length > 0 &&
      attributeDetails[0].attributeType.typeName === "NumericMax"
    ) {
      retVal = itemv.floatValue !== null ? itemv.floatValue : "";
    }

    return retVal;
  }

  const accommodationVarusteluAttributeItems = accommodationAttributes
    ?.filter(
      (ai) =>
        getAttributeIsVarustelu(ai.attributeId) === true &&
        !(
          getAttributeItemType(ai.attributeId) === "Boolean" && !ai.booleanValue
        ),
    )
    .map((item, index) => (
      <tr key={Math.random()} className="position-relative">
        <td>{getAttributeItem(item.attributeId)}</td>
        <td>
          {getAttributeItemType(item.attributeId) === "Boolean" &&
            item.booleanValue && (
              <span className="bi bi-check-lg text-success me-4">
                <span className="visually-hidden">Kyllä</span>
              </span>
            )}
          {getAttributeItemType(item.attributeId) === "Boolean" &&
            !item.booleanValue && (
              <span className="bi bi-x-lg text-danger me-4">
                <span className="visually-hidden">Ei</span>
              </span>
            )}
          {getAttributeItemType(item.attributeId) !== "Boolean" &&
            getAttributeItemValue(item.attributeId, item)}
        </td>
      </tr>
    ));

  if (accommodationAttributes == null || allAccommodationAttributes == null) {
    return <></>;
  }
  //console.log(accommodationAttributes);
  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th scope="col" className="col-4">
              Varuste
            </th>
            <th scope="col">Lisätieto</th>
          </tr>
        </thead>
        <tbody>
          {accommodationAttributes != null &&
            allAccommodationAttributes != null &&
            accommodationVarusteluAttributeItems}
        </tbody>
      </table>
    </>
  );
};

export default AccommodationServices;
export { AccommodationServices };
